import React from 'react';
import {
  Dialog,
  DialogContent,
  DialogActions,
  Button,
  Typography,
  Box,
} from '@mui/material';
import { Phone as PhoneIcon } from '@mui/icons-material';

interface CallInitiatedModalProps {
  open: boolean;
  onClose: () => void;
  phoneNumber: string;
  recipientType?: 'customer' | 'agent'; // Default to 'customer'
}

const CallInitiatedModal: React.FC<CallInitiatedModalProps> = ({
  open,
  onClose,
  phoneNumber,
  recipientType = 'customer',
}) => {
  const message = recipientType === 'agent'
    ? "You will receive a call on this number. Please pick up to connect with the Agent."
    : "You will receive a call on this number. Please pick up to connect with the customer.";
  return (
    <Dialog
      open={open}
      onClose={onClose}
      maxWidth="xs"
      fullWidth
      PaperProps={{
        sx: {
          borderRadius: 3,
          p: 2,
        },
      }}
    >
      <DialogContent sx={{ textAlign: 'center', py: 4 }}>
        <Box
          sx={{
            display: 'flex',
            flexDirection: 'column',
            alignItems: 'center',
            gap: 2,
          }}
        >
          {/* Call Initiated Icon */}
          <Box
            sx={{
              width: 64,
              height: 64,
              borderRadius: '50%',
              backgroundColor: '#e8f5e9',
              display: 'flex',
              alignItems: 'center',
              justifyContent: 'center',
            }}
          >
            <PhoneIcon
              sx={{
                fontSize: 40,
                color: '#2e7d32',
              }}
            />
          </Box>

          {/* Phone Number */}
          <Typography variant="h6" fontWeight="bold" color="text.primary">
            {phoneNumber}
          </Typography>

          {/* Message */}
          <Typography
            variant="body2"
            color="text.secondary"
            sx={{ maxWidth: '90%', lineHeight: 1.6 }}
          >
            {message}
          </Typography>
        </Box>
      </DialogContent>

      <DialogActions sx={{ justifyContent: 'center', pb: 2, px: 2 }}>
        <Button
          onClick={onClose}
          variant="contained"
          sx={{
            backgroundColor: '#000000',
            color: 'white',
            textTransform: 'none',
            borderRadius: 2,
            px: 4,
            py: 1,
            fontWeight: 'medium',
            '&:hover': {
              backgroundColor: '#333333',
            },
          }}
        >
          OK
        </Button>
      </DialogActions>
    </Dialog>
  );
};

export default CallInitiatedModal;
